module.exports = __webpack_public_path__ + "media/litigation_finance_101/hero-0044855a.jpg";